import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import swal from "sweetalert";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";

import { GetLanguageString } from "../../helper/Components";
import { ApiUnit } from "../../unit/ApiUnit";
import { GetSelectedLanguage } from "../../helper/Method";
import { convertToDateString, LoadingSpinner } from "../../../constants/const";
import SelectResponsibilityData from "./SelectResponsibilityData";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { addMember } from "../ApiMember";
import ResponsibilityErrorMessage from "./ResponsibilityErrorMessage";
import Draggable from "react-draggable";
import SelectPreviousResponsibilityData from "./SelectPreviousResponsibilityData";

const EditMemberResponsibility = ({
  unitId,
  loading1,
  memberId,
  editResponsibility,
  setUpdatedDetails,
  editResponsibilityModal,
  setEditResponsibilityModal,
  setResponsibilityStateChange,
}) => {
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [responsibilityValues, setResponsibilityValues] = useState({
    ...editResponsibility,
    responsibility: editResponsibility.responsibility,
    responsibilityDate: editResponsibility.responsibilityDate
      ? new Date(editResponsibility.responsibilityDate)
      : null,
    responsibilityEndDate: editResponsibility.responsibilityEndDate
      ? new Date(editResponsibility.responsibilityEndDate)
      : null,
    displayName: editResponsibility.displayName,
  });

  // responsibilityValues.displayName = editResponsibility.displayName
  const [unitList, setUnitList] = useState([]);
  const [loadings, setLoadings] = useState(loading1);
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const { t } = useTranslation();
  const [displayMessageModal, setDisplayMessageModal] = useState(false);
  const notify = (string) => toast.success(string);
  const unitTypeName = "null";
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const toggle = () => {
    setEditResponsibilityModal(false);
  };

  useEffect(() => {
    ApiUnit()
      .getUnitList(unitId, loggedInUnitId, false, unitTypeName)
      .then((res) => {
        setUnitList(res.data);
        setLoadings(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadings(false);
      });
  }, [unitId, loggedInUnitId]);

  const handleChangeUnits = (record) => {
    if (record !== null) {
      ApiUnit()
        .getUnitList(record.value, loggedInUnitId, false, unitTypeName)
        .then((res) => {
          setUnitList(res.data);
        })
        .catch((err) => console.log(err));

      setResponsibilityValues({
        ...responsibilityValues,
        unit: record,
      });
    }
  };

  const [errors, setErrors] = useState({
    responsibilityDate: "",
    responsibilityEndDate: "",
    responsibility: "",
    displayName: "",
  });

  const validate = () => {
    let temp = {};
    temp.responsibilityDate =
      responsibilityValues.responsibilityDate !== null ? (
        ""
      ) : (
        <GetLanguageString props="member_member_details_responsibility_date_error_message" />
      );

    temp.responsibility =
      responsibilityValues.responsibility.value !== 0 ? (
        ""
      ) : (
        <GetLanguageString props="member_member_details_responsibility_error_message" />
      );

    if (responsibilityValues.responsibility.isMultiple) {
      temp.displayName =
        responsibilityValues.responsibility.isMultiple &&
        responsibilityValues.displayName !== "" ? (
          ""
        ) : (
          <GetLanguageString props="responsibility_title_err" />
        );
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setButtonDisable(true);
      setLoading(true);
      responsibilityValues.responsibilityDate = convertToDateString(
        responsibilityValues.responsibilityDate
      );
      responsibilityValues.responsibilityEndDate = convertToDateString(
        responsibilityValues.responsibilityEndDate
      );
      addMember()
        .editMemberResponsibility(responsibilityValues)
        .then((res) => {
          if (
            !res.data.thisMemberHaveResponsibility &&
            !res.data.otherMemberHaveResponsibility
          ) {
            swal({
              title: t("member__member_responsibility_added_success_message"),
              icon: "success",
              buttons: "OK",
              className: GetSelectedLanguage() === "en" ? "" : "ur",
            });
            setLoading(false);
            setResponsibilityStateChange((prevState) => !prevState);
            toggle();
            setButtonDisable(false);
            setUpdatedDetails((prevState) => !prevState);
          } else if (res.data === "Your request for modification is sent.") {
            notify(res.data);
            setLoading(false);
            toggle();
            setButtonDisable(false);
          } else {
            setErrorMessages(res.data);
            setDisplayMessageModal(true);
            setLoading(false);
            setButtonDisable(false);
          }
        })
        .catch((err) => {
          swal({
            title: t(err.response.data),
            icon: "error",
            buttons: "OK",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
          });
          console.log(err.response.data);
          setLoading(false);
          setButtonDisable(false);
        });
    }
  };

  return (
    <>
      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal
          size="lg"
          isOpen={editResponsibilityModal}
          className="inmodal"
          autoFocus={false}
        >
          {displayMessageModal ? (
            <ResponsibilityErrorMessage
              setDisplayMessageModal={setDisplayMessageModal}
              data={errorMessages}
              displayName={responsibilityValues.displayName}
            />
          ) : null}
          <ModalHeader className="modal-title" tag="h4">
            {<GetLanguageString props="settings_edit_responsibility" />}
          </ModalHeader>
          <ModalBody>
            {!loading ? (
              !loadings ? (
                <Row>
                  <div className="col-md-12">
                    <Row>
                      <Label className="col-form-label">
                        <GetLanguageString props="member_select_responsibility_unit" />
                      </Label>
                      {unitList.map((record, index) => {
                        const unitOptions = [];
                        record.unitList.forEach((d) =>
                          unitOptions.push({ value: d.id, label: d.name })
                        );
                        let selected = {};
                        if (record.selectedUnit !== null) {
                          selected = {
                            value: record.selectedUnit.id,
                            label: record.selectedUnit.name,
                          };
                        }

                        const isLastIndex = index === unitList.length - 1;

                        return (
                          <>
                            <Col md="4" key={index}>
                              <FormGroup>
                                <Row>
                                  <Col md="10">
                                    <Select
                                      options={unitOptions}
                                      value={selected}
                                      className="basic-single ur no-drag"
                                      classNamePrefix="select"
                                      isDisabled
                                      onChange={handleChangeUnits}
                                    />
                                  </Col>
                                  {isLastIndex ? null : (
                                    <Col md="2" className="p-0">
                                      {GetSelectedLanguage() === "en" ? (
                                        <i className="fa fa-arrow-right fa-lg m"></i>
                                      ) : (
                                        <i className="fa fa-arrow-left fa-lg m"></i>
                                      )}
                                    </Col>
                                  )}
                                </Row>
                              </FormGroup>
                            </Col>
                          </>
                        );
                      })}
                    </Row>
                    <div>
                      {editResponsibility?.isCurrent ?
                        <SelectResponsibilityData
                          setValues={setResponsibilityValues}
                          setLoadings={setLoadings}
                          values={responsibilityValues}
                          errors={errors}
                          setErrors={setErrors}
                          selectedUnit={responsibilityValues?.unit?.value}
                          memberId={memberId}
                          editResponsibilityDate={
                            editResponsibility.responsibilityDate
                              ? new Date(editResponsibility.responsibilityDate)
                              : null
                          }
                          type={"edit"}
                        /> 
                        :
                        <SelectPreviousResponsibilityData
                          setValues={setResponsibilityValues}
                          setLoadings={setLoadings}
                          values={responsibilityValues}
                          errors={errors}
                          setErrors={setErrors}
                          selectedUnit={responsibilityValues?.unit?.value}
                          memberId={memberId}
                          responsibilityDate={
                            editResponsibility.responsibilityDate
                              ? new Date(editResponsibility.responsibilityDate)
                              : null
                          }
                          responsibilityEndDate={
                            editResponsibility.responsibilityEndDate
                              ? new Date(editResponsibility.responsibilityEndDate)
                              : null
                          }
                          type={"edit"}
                        />
                      }
                    </div>
                  </div>
                </Row>
              ) : (
                LoadingSpinner()
              )
            ) : (
              LoadingSpinner()
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="white" onClick={toggle}>
              {<GetLanguageString props="common_cancel" />}
            </Button>
            <Button
              color="primary"
              disabled={buttonDisable}
              type="submit"
              onClick={handleSubmit}
            >
              {<GetLanguageString props="common_save_changes" />}
            </Button>
          </ModalFooter>
        </Modal>
      </Draggable>
    </>
  );
};

export default EditMemberResponsibility;
